export default __webpack_public_path__ + "static/media/ibm_logo.344b08dc.png";